module.exports = __webpack_public_path__ + "static/BayviewImage-Website-69a184da66422c61552b353e0a4e63c8.png";